// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b3e9175","239":"b03e0b1c","453":"d9176dce","732":"a044e03a"}[chunkId] + ".chunk.js";
};